import { createSelector } from '@reduxjs/toolkit';
import {
  selectOptionsAsap,
  selectOptionsEmailSignature, selectOptionsPercentTotal,
  selectOptionsPlusTotal,
  selectProjectsDetails
} from '../project/projectSelectros';

export const selectEmailSignature = createSelector(
  selectProjectsDetails,
  projectsDetails => projectsDetails?.email || {}
);

export const selectEmailSignatureCalculationParams = createSelector(
  selectEmailSignature,
  projectOther => projectOther.calculationOptions || {}
);

export const selectEmailSignaturePagesTotal = createSelector(
  selectOptionsEmailSignature,
  (options) => {
    const  option = options.length ? options[0] : {};
    return {
      discount: 0,
      totalPricePages: option?.priceValue || 0
    }
  }
)

export const selectEmailSignatureOptionsTotal = createSelector(
  selectEmailSignaturePagesTotal,
  selectOptionsPlusTotal,
  selectOptionsPercentTotal,
  ({totalPricePages}, totalPricePlusOptions, totalPricePercentOptions) => {
    const totalPriceOfPercent = Math.ceil((totalPricePercentOptions / 100) * totalPricePages);
    return totalPriceOfPercent + totalPricePlusOptions;
  }
);

export const selectEmailSignatureTotal = createSelector(
  selectEmailSignaturePagesTotal,
  selectEmailSignatureOptionsTotal,
  selectOptionsAsap,
  ({totalPricePages}, totalPriceOptions, asap) => {
    const  isASAP = asap.length;
    return isASAP ? (totalPricePages + totalPriceOptions) * 2 : totalPricePages + totalPriceOptions
  }
);

export const selectEmailSignatureTotalForAsap = createSelector(
    selectEmailSignatureTotal,
    (totalPrice) => {
        return totalPrice / 2;
    }
);

export const selectEmailSignatureEta = () => ({
  etaText: '',
  etaIsExists: false
});

export const selectEmailSignatureDiscount = () => ({
  discountIsExists: false,
  discountText: '',
  discountPrice: 0,
});
